import { render, staticRenderFns } from "./GameRecommend.vue?vue&type=template&id=56fc8584&scoped=true&"
import script from "./GameRecommend.vue?vue&type=script&lang=js&"
export * from "./GameRecommend.vue?vue&type=script&lang=js&"
import style0 from "./GameRecommend.vue?vue&type=style&index=0&id=56fc8584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc8584",
  null
  
)

export default component.exports